import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createPunch, getPunchByEmployeeId, getPunchByEmployeeWithId } from "../../../core/data/redux/attendance/punch/punchAction";
import { Modal, Button } from "antd";
import Webcam from "react-webcam";
import { AppDispatch } from "../../../core/data/redux/store";
import { getGreeting } from "../../../core/common/GlobalFunctions/greetingByTIme";
import { getCurrentLocation } from "../../../core/common/GlobalFunctions/currentLocation";
import { getEmployeeByUserId } from "../../../core/data/redux/employee/employeeAction";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../router/all_routes";
import { formatDate } from "../../../core/utils/configFormatters";
import { formatTimeOnly } from "../../../core/utils/formatTime";
import { exportToCSV, exportToExcel, exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import Table from "../../../core/common/dataTable/index";
import { fetchEmployeeTime } from "../../../core/data/redux/reports/attendance_report/attendacnereport.Action";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { fetchEmployeePunchStats, fetchEmployeeStats } from "../../../core/data/redux/dashboards/admindashboard/adminDashboardActions";
import { decryptData } from "../../../core/utils/encryptUtils";


const AttendanceEmployee = () => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [capturedImage, setCapturedImage] = useState<string | undefined | null>(undefined);
  const [punchInTime, setPunchInTime] = useState<string | null>(null);
  const [duration, setDuration] = useState<string | null>(null);
  const [punchOutTime, setPunchOutTime] = useState<string | null>(null);
  const [isWebcamModalVisible, setIsWebcamModalVisible] =
    useState<boolean>(false);
  const [currentTime, setCurrentTime] = useState<string>("");
  const [webcamKey, setWebcamKey] = useState(0);
  const [getEmployeetime, setEmployeetime] = useState<any[]>([]);
  const webcamRef = useRef<Webcam>(null);
  const dispatch = useDispatch<AppDispatch>();
  const { punches } = useSelector((state: any) => state.attendance.punch);
  console.log(punches, 'punches');
  const { punchess } = useSelector((state: any) => state.attendance.punch);
  console.log(punchess, "punchessss");
  const { user } = useSelector((state: any) => state.auth);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  console.log(employeesbyUser, 'userD')
  const [stats, setstats] = useState<any>("")
  const [punchstats, setpunchstats] = useState<any>("")
  const employeeId = employeesbyUser?.employeeId;


  // Permission
  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");


  useEffect(() => {
    if (user?.UserId) {
      dispatch(getEmployeeByUserId({ userId: user?.UserId }));
    }
  }, [dispatch, employeesbyUser.length, user?.UserId]);




  const stopCamera = () => {
    if (webcamRef.current) {
      const videoElement = webcamRef.current.video;
      if (videoElement?.srcObject) {
        const stream = videoElement.srcObject as MediaStream;
        stream.getTracks().forEach((track) => track.stop());
        videoElement.srcObject = null;
      }
    }
  };

  const today = new Date().toISOString().split("T")[0];
  const lastPunch = punches.find((punch: any) =>
    punch.PunchIn?.startsWith(today)
  );

  const nextAction = lastPunch?.nextAction || 'IN';

  // Update the current time every minute
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const formattedTime = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
      const formattedDate = now.toLocaleDateString([], {
        weekday: "short",
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
      setCurrentTime(`${formattedTime}, ${formattedDate}`);
    };
    const intervalId = setInterval(updateTime, 60000);
    updateTime();
    return () => clearInterval(intervalId);
  }, []);

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, "0");
    const day = `${today.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const todayDate = getTodayDate();

  useEffect(() => {
    if (employeeId) {
      dispatch(
        fetchEmployeeTime({ employeeId: employeeId, date: todayDate })
      ).then((res) => {
        if (res.payload?.data) {
          setEmployeetime(res.payload.data);
        } else {
          setEmployeetime([]);
        }
      });
      dispatch(getPunchByEmployeeWithId(employeeId))
    }

    if (employeeId) {
      dispatch(fetchEmployeeStats(employeeId))
        .then((res) => {
          setstats(res.payload.data)
        })
      dispatch(fetchEmployeePunchStats(employeeId))
        .then((res) => {
          setpunchstats(res.payload.data)
        })
    }
  }, [dispatch, user?.UserId, employeeId]);

  // Fetch Punch-in and Punch-out details, and calculate duration
  useEffect(() => {
    if (employeesbyUser?.employeeNumber && punches.length === 0) {
      dispatch(getPunchByEmployeeId(employeesbyUser?.employeeNumber));
    } else if (lastPunch) {
      const punchInDate = new Date(lastPunch.PunchIn);
      const punchOutDate = lastPunch.PunchOut
        ? new Date(lastPunch.PunchOut)
        : null;
      const formattedTime = formatTime(punchInDate);
      const formattedOutTime = punchOutDate ? formatTime(punchOutDate) : null;

      setPunchInTime(formattedTime);
      setPunchOutTime(formattedOutTime);
      if (lastPunch.CheckInImagePath) {
        setPreviewImage(lastPunch.CheckInImagePath);
      }
      if (punchOutDate) {
        const duration = calculateDuration(punchInDate, punchOutDate);
        setDuration(duration);
      }
    }
  }, [punches, dispatch, employeesbyUser?.employeeNumber, lastPunch]);

  const formatTime = (date: Date) =>
    date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  const calculateDuration = (punchInDate: Date, punchOutDate: Date) => {
    const durationInSeconds =
      Math.abs(punchOutDate.getTime() - punchInDate.getTime()) / 1000;
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  const handlePunchIn = async (capturedFile: File) => {
    const { latitude, longitude } = await getCurrentLocation();
    const punchData = {
      EmployeeId: employeeId,
      PunchDate: new Date().toISOString(),
      PunchTime: new Date().toISOString(),
      Longitude: longitude,
      Latitude: latitude,
      CreatedBy: user?.UserId,
      PunchType: "IN",
      file: capturedFile,
      EmployeeCode: employeesbyUser?.employeeNumber,
    };
    await dispatch(createPunch(punchData));
    await dispatch(getPunchByEmployeeId(employeesbyUser?.employeeNumber));

    if (employeeId) {
      dispatch(fetchEmployeePunchStats(employeeId)).then((res) => {
        setpunchstats(res.payload?.data);
      });
    }
    dispatch(fetchEmployeeTime({ employeeId: employeeId, date: todayDate })).then((res) => {
      if (res.payload?.data) {
        setEmployeetime(res.payload.data);
      } else {
        setEmployeetime([]);
      }
    });
  };

  const captureCheckoutImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        const imageFile = base64ToFile(imageSrc, "checkout-image.jpg");
        setCapturedImage(imageSrc);
        stopCamera();
        setIsWebcamModalVisible(false);
        handleCheckout(imageFile);
      }
    }
  };

  const handleCheckout = async (capturedFile: File) => {
    const { latitude, longitude } = await getCurrentLocation();
    if (!lastPunch || !lastPunch.Id) {
      alert("No active punch-in record found.");
      return;
    }
    const punchOutTime = new Date().toISOString();
    const punchInDate = new Date(lastPunch.PunchIn);
    const punchOutDate = new Date(punchOutTime);
    const duration = calculateDuration(punchInDate, punchOutDate);

    const updateData = {
      EmployeeId: employeeId,
      PunchDate: new Date().toISOString(),
      PunchTime: new Date().toISOString(),
      Longitude: longitude,
      Latitude: latitude,
      CreatedBy: user?.UserId,
      PunchType: "OUT",
      file: capturedFile,
      EmployeeCode: employeesbyUser?.employeeNumber,
    };

    // const updateData = {
    //   PunchOut: punchOutTime,
    //   Duration: duration,
    //   ModifiedBy: user?.UserId,
    //   CheckOutImage: capturedFile,
    // };
    await dispatch(createPunch(updateData));
    await dispatch(getPunchByEmployeeId(employeesbyUser?.employeeNumber));

    if (employeeId) {
      dispatch(fetchEmployeePunchStats(employeeId)).then((res) => {
        setpunchstats(res.payload?.data);
      });
      dispatch(fetchEmployeeTime({ employeeId: employeeId, date: todayDate })).then((res) => {
        if (res.payload?.data) {
          setEmployeetime(res.payload.data);
        } else {
          setEmployeetime([]);
        }
      });
    }

  };


  useEffect(() => {
    dispatch(getPunchByEmployeeWithId(employeeId))
  }, [dispatch])

  const showWebcamModal = () => {
    setCapturedImage(null);
    setIsWebcamModalVisible(true);
    setWebcamKey((prevKey) => prevKey + 1);
  };

  const handleWebcamCancel = () => {
    stopCamera();
    setIsWebcamModalVisible(false);
    setCapturedImage(null);
  };

  const captureImage = () => {
    if (webcamRef.current) {
      const imageSrc = webcamRef.current.getScreenshot();
      if (imageSrc) {
        const imageFile = base64ToFile(imageSrc, "captured-image.jpg");
        setCapturedImage(imageSrc);
        stopCamera();
        setIsWebcamModalVisible(false);
        handlePunchIn(imageFile);
      }
    }
  };

  const base64ToFile = (base64String: string, filename: string): File => {
    const byteString = atob(base64String.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      uint8Array[i] = byteString.charCodeAt(i);
    }
    return new File([uint8Array], filename, { type: "image/jpeg" });
  };

  const convertDurationToHours = (duration: string): number => {
    const [hours, minutes, seconds] = duration.split(":").map(Number);
    return hours + minutes / 60 + seconds / 3600;
  };

  const data = punchess ? punchess : [];

  const exportAttendanceEmployee = data.map((item: any) => ({
    PunchDate: item.PunchDate ? new Date(item.PunchDate).toLocaleDateString("en-IN") : "N/A",
    PunchIn: item.PunchIn ? new Date(item.PunchIn).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "N/A",
    PunchOut: item.PunchOut ? new Date(item.PunchOut).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", second: "2-digit" }) : "N/A",
    Duration: item.Duration || "N/A",
    CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toLocaleDateString("en-IN") : "N/A",
    ModifiedAt: item.ModifiedAt ? new Date(item.ModifiedAt).toLocaleDateString("en-IN") : "N/A",
    Longitude: item.Longitude || "N/A",
    Latitude: item.Latitude || "N/A",
  }));




  const filteredData = useMemo(() => {
    const filters = selectedStatus ? { status: selectedStatus } : {};
    return filterData(
      data || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [data, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, punchess]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Date",
      dataIndex: "PunchDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => a.PunchDate.length - b.PunchDate.length,
    },
    {
      title: "Check In",
      dataIndex: "PunchIn",
      render: (text: string) => formatTimeOnly(text),
      sorter: (a: any, b: any) => a.PunchIn.length - b.PunchIn.length,
    },
    {
      title: "Check Out",
      dataIndex: "PunchOut",
      render: (text: string) => formatTimeOnly(text) || "00",
      sorter: (a: any, b: any) => a.PunchOut - b.PunchOut,
    },
    {
      title: "Break",
      dataIndex: "breakDuration",
      render: (_: any, record: any) =>
        record?.breaks?.length > 0 ? record.breaks[0].breakDuration : "00",
      sorter: (a: any, b: any) => {
        const getBreak = (r: any) =>
          r?.breaks?.length > 0 ? r.breaks[0].breakDuration : "00:00:00";
        return getBreak(a).localeCompare(getBreak(b));
      }
    },

    {
      title: "Late",
      dataIndex: "lateLogin",
      render: (text: string) => text || "00",
      sorter: (a: any, b: any) => a.lateLogin - b.lateLogin,
    },
    {
      title: "Overtime",
      dataIndex: "overtime",
      render: (text: string) => text || "00",
      sorter: (a: any, b: any) => a.overtime - b.overtime,
    },
    {
      title: "Productive Hours",
      dataIndex: "Duration",
      render: (text: String, record: any) => (
        <span
          className={`badge d-inline-flex align-items-center badge-sm ${record.ProductionHours < "8.00"
            ? "badge-danger"
            : record.Duration >= "8.00" && record.Duration <= "9.00"
              ? "badge-success"
              : "badge-info"
            }`}
        >
          <i className="ti ti-clock-hour-11 me-1"></i>
          {record.Duration}
        </span>
      ),
      sorter: (a: any, b: any) => a.Duration - b.Duration,
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Employee Attendance</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Attendance</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Employee Attendance
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
            {/* <div className="me-2 mb-2">
              <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
                <Link
                  to={all_routes.attendanceemployee}
                  className="btn btn-icon btn-sm active bg-primary text-white me-1"
                >
                  <i className="ti ti-brand-days-counter" />
                </Link>
                <Link
                  to={all_routes.attendanceadmin}
                  className="btn btn-icon btn-sm"
                >
                  <i className="ti ti-calendar-event" />
                </Link>
              </div>
            </div> */}
            <div className="me-2 mb-2">
              {canExport && (
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(exportAttendanceEmployee, "Attendance_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(exportAttendanceEmployee, "Attendance_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToPDF(exportAttendanceEmployee, "Attendance_data")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as PDF{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            {/* <div className="mb-2">
              <Link
                to="#"
                className="btn btn-primary d-flex align-items-center"
                data-bs-toggle="modal"
                data-inert={true}
                data-bs-target="#attendance_report"
              >
                <i className="ti ti-file-analytics me-2" />
                Report
              </Link>
            </div> */}
            <div className="ms-2 head-icons">
              <CollapseHeader />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-lg-4 d-flex">
            <div className="card flex-fill border-primary attendance-bg">
              <div className="card-body">
                <div className="mb-3 text-center">
                  <h6 className="fw-medium text-gray-5 mb-2">
                    {getGreeting()}, {lastPunch?.Name}
                  </h6>
                  <h4>{currentTime}</h4>
                </div>
                <div className="attendance-circle-progress mx-auto mb-3">
                  <div className="avatar avatar-xxl avatar-rounded">
                    <img
                      src={capturedImage || previewImage || "https://cdn-icons-png.flaticon.com/512/149/149071.png"}
                      alt="Profile Preview"
                      className="avatar-img"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  </div>
                </div>
                <div className="text-center">
                  <div className="badge badge-md badge-primary mb-3">
                    Productive :: {getEmployeetime?.[0]?.ProductiveTime || "00:00"}
                  </div>
                  <h6 className="fw-medium d-flex align-items-center justify-content-center mb-3">
                    <i className="ti ti-fingerprint text-primary me-1" />
                    {punchInTime
                      ? `Check In at ${punchInTime}`
                      : "Check In time not available"}
                  </h6>
                  <h6 className="fw-medium d-flex align-items-center justify-content-center mb-3">
                    <i className="ti ti-fingerprint text-primary me-1" />
                    {lastPunch && lastPunch.PunchOut
                      ? `Check Out at ${punchOutTime}`
                      : "Check Out time not available"}
                  </h6>
                  <Link
                    to="#"
                    className="btn btn-dark w-100"
                    onClick={showWebcamModal}
                  >
                    {nextAction === 'OUT' ? 'Checkout' : 'Check In'}
                  </Link>
                </div>
              </div>
            </div>
            <Modal
              visible={isWebcamModalVisible}
              onCancel={handleWebcamCancel}
              footer={null}
              width={400}
              title="Capture Image"
            >
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Webcam
                  key={webcamKey} // Remount on modal open
                  ref={webcamRef}
                  audio={false}
                  screenshotFormat="image/jpeg"
                  width="100%"
                  videoConstraints={{ facingMode: "user" }}
                />
              </div>
              <Button
                type="primary"
                onClick={nextAction === 'OUT' ? captureCheckoutImage : captureImage}
                className="mt-2"
              >
                Submit
              </Button>
            </Modal>
          </div>
          <div className="col-xl-9 col-lg-8 d-flex">
            <div className="row flex-fill">
              <div className="row g-3">
                <div className="col-xl-4 col-md-4">
                  <div className="card shadow-sm p-3" style={{ height: "100px" }}>
                    <div className="d-flex align-items-center h-100">
                      <span className="avatar avatar-sm bg-primary me-3">
                        <i className="ti ti-clock-stop fs-3" />
                      </span>
                      <div>
                        <div style={{ fontWeight: "bold", fontSize: "20px", marginBottom: "4px" }}>
                          Today Hours
                        </div>
                        <div style={{ fontWeight: "300px", fontSize: "16px", color: "#212529" }}>
                          {punchstats ? punchstats?.punchStats[0].today_duration : "0"}/
                          {punchstats ? punchstats?.shiftStats[0].today_hours : "0"}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-md-4">
                  <div className="card shadow-sm p-3" style={{ height: "100px" }}>
                    <div className="d-flex align-items-center h-100">
                      <span className="avatar avatar-sm bg-dark me-3">
                        <i className="ti ti-clock-up fs-3" />
                      </span>
                      <div>
                        <div style={{ fontWeight: "bold", fontSize: "20px", marginBottom: "4px" }}>Week Hours</div>
                        <div style={{ fontWeight: "300px", fontSize: "16px", color: "#212529" }}>
                          {punchstats ? punchstats?.punchStats[0].week_duration : "0"}/
                          {punchstats ? punchstats?.shiftStats[0].week_hours : "0"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-md-4">
                  <div className="card shadow-sm p-3" style={{ height: "100px" }}>
                    <div className="d-flex align-items-center h-100">
                      <span className="avatar avatar-sm bg-info me-3">
                        <i className="ti ti-calendar-up fs-3" />
                      </span>
                      <div>
                        <div style={{ fontWeight: "bold", fontSize: "20px", marginBottom: "4px" }}>Month Hours</div>
                        <div style={{ fontWeight: "300px", fontSize: "16px", color: "#212529" }}>
                          {punchstats ? punchstats?.punchStats[0].month_duration : "0"}/
                          {punchstats ? punchstats?.shiftStats[0].month_hours : "0"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3 text-center">
                          <p className="d-flex align-items-center justify-content-center mb-1">
                            <i className="ti ti-point-filled text-dark-transparent me-1" />
                            Total Working hours
                          </p>
                          <h3>
                            {getEmployeetime?.[0]?.TotalWorkingHours || "00:00"}
                          </h3>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-3 text-center">
                          <p className="d-flex align-items-center justify-content-center mb-1">
                            <i className="ti ti-point-filled text-success me-1" />
                            Productive Hours
                          </p>
                          <h3>
                            {getEmployeetime?.[0]?.ProductiveTime || "00:00"}
                          </h3>
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="mb-3 text-center">
                          <p className="d-flex align-items-center justify-content-center mb-1">
                            <i className="ti ti-point-filled text-warning me-1" />
                            Break Hours
                          </p>
                          <h3>{getEmployeetime?.[0]?.BreakTime || "00:00"}</h3>
                        </div>
                      </div>
                    </div>

                    {/* Dynamic Progress Bar */}
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className="progress bg-light mb-3"
                          style={{ height: 24 }}
                        >
                          {(() => {
                            const timeToMinutes = (timeStr: any) => {
                              const [h, m] = (timeStr || "00:00")
                                .split(":")
                                .map(Number);
                              return h * 60 + m;
                            };

                            const total = timeToMinutes(
                              getEmployeetime?.[0]?.TotalWorkingHours
                            );
                            const productive = timeToMinutes(
                              getEmployeetime?.[0]?.ProductiveTime
                            );
                            const breakTime = timeToMinutes(
                              getEmployeetime?.[0]?.BreakTime
                            );
                            const productivePercent = total
                              ? (productive / total) * 100
                              : 0;
                            const breakPercent = total
                              ? (breakTime / total) * 100
                              : 0;

                            return (
                              <>
                                <div
                                  className="progress-bar bg-success rounded-start"
                                  role="progressbar"
                                  style={{ width: `${productivePercent}%` }}
                                  title={`Productive Time (${productivePercent.toFixed(
                                    1
                                  )}%)`}
                                />
                                <div
                                  className="progress-bar bg-warning rounded-end"
                                  role="progressbar"
                                  style={{ width: `${breakPercent}%` }}
                                  title={`Break Time (${breakPercent.toFixed(
                                    1
                                  )}%)`}
                                />
                              </>
                            );
                          })()}
                        </div>
                      </div>

                      {/* Optional: Time Markers */}
                      <div className="col-md-12">
                        <div className="d-flex justify-content-between fs-10">
                          <span>Day Start</span>
                          <span>Day Finish</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <h5>Attendance List</h5>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="dropdown">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  {selectedSort
                    ? `Sort By : ${selectedSort}`
                    : "Sort By : Last 7 Days"}
                </Link>
                <ul className="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Recently Added")}
                      className="dropdown-item rounded-1"
                    >
                      Recently Added
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Ascending")}
                      className="dropdown-item rounded-1"
                    >
                      Ascending
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Descending")}
                      className="dropdown-item rounded-1"
                    >
                      Descending
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Last Month")}
                      className="dropdown-item rounded-1"
                    >
                      Last Month
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="#"
                      onClick={() => setSelectedSort("Last 7 Days")}
                      className="dropdown-item rounded-1"
                    >
                      Last 7 Days
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="card-body p-0">
            <Table
              key={tableKey}
              dataSource={filteredData}
              columns={columns}
              Selection={true}
            />
          </div>
        </div>
      </div>

      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0">2024 - 2025© hrmtree.</p>
        <p>
          Developed By{" "}
          <Link to="#" className="text-primary">
            Leadchain Systems
          </Link>
        </p>
      </div>

      {/* Attendance Report */}
      <div className="modal fade" id="attendance_report">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Attendance</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="modal-body">
              <div className="card shadow-none bg-transparent-light">
                <div className="card-body pb-1">
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="mb-3">
                        <span>Date</span>
                        <p className="text-gray-9 fw-medium">15 Apr 2025</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-3">
                        <span>Check in at</span>
                        <p className="text-gray-9 fw-medium">09:00 AM</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-3">
                        <span>Check out at</span>
                        <p className="text-gray-9 fw-medium">06:45 PM</p>
                      </div>
                    </div>
                    <div className="col-sm-3">
                      <div className="mb-3">
                        <span>Status</span>
                        <p className="text-gray-9 fw-medium">Present</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card shadow-none border mb-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-xl-3">
                      <div className="mb-4">
                        <p className="d-flex align-items-center mb-1">
                          <i className="ti ti-point-filled text-dark-transparent me-1" />
                          Total Working hours
                        </p>
                        <h3>12h 36m</h3>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="mb-4">
                        <p className="d-flex align-items-center mb-1">
                          <i className="ti ti-point-filled text-success me-1" />
                          Productive Hours
                        </p>
                        <h3>08h 36m</h3>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="mb-4">
                        <p className="d-flex align-items-center mb-1">
                          <i className="ti ti-point-filled text-warning me-1" />
                          Break hours
                        </p>
                        <h3>22m 15s</h3>
                      </div>
                    </div>
                    <div className="col-xl-3">
                      <div className="mb-4">
                        <p className="d-flex align-items-center mb-1">
                          <i className="ti ti-point-filled text-info me-1" />
                          Overtime
                        </p>
                        <h3>02h 15m</h3>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-8 mx-auto">
                      <div
                        className="progress bg-transparent-dark mb-3"
                        style={{ height: 24 }}
                      >
                        <div
                          className="progress-bar bg-success rounded me-2"
                          role="progressbar"
                          style={{ width: "18%" }}
                        />
                        <div
                          className="progress-bar bg-warning rounded me-2"
                          role="progressbar"
                          style={{ width: "5%" }}
                        />
                        <div
                          className="progress-bar bg-success rounded me-2"
                          role="progressbar"
                          style={{ width: "28%" }}
                        />
                        <div
                          className="progress-bar bg-warning rounded me-2"
                          role="progressbar"
                          style={{ width: "17%" }}
                        />
                        <div
                          className="progress-bar bg-success rounded me-2"
                          role="progressbar"
                          style={{ width: "22%" }}
                        />
                        <div
                          className="progress-bar bg-warning rounded me-2"
                          role="progressbar"
                          style={{ width: "5%" }}
                        />
                        <div
                          className="progress-bar bg-info rounded me-2"
                          role="progressbar"
                          style={{ width: "3%" }}
                        />
                        <div
                          className="progress-bar bg-info rounded"
                          role="progressbar"
                          style={{ width: "2%" }}
                        />
                      </div>
                    </div>
                    <div className="co-md-12">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fs-10">06:00</span>
                        <span className="fs-10">07:00</span>
                        <span className="fs-10">08:00</span>
                        <span className="fs-10">09:00</span>
                        <span className="fs-10">10:00</span>
                        <span className="fs-10">11:00</span>
                        <span className="fs-10">12:00</span>
                        <span className="fs-10">01:00</span>
                        <span className="fs-10">02:00</span>
                        <span className="fs-10">03:00</span>
                        <span className="fs-10">04:00</span>
                        <span className="fs-10">05:00</span>
                        <span className="fs-10">06:00</span>
                        <span className="fs-10">07:00</span>
                        <span className="fs-10">08:00</span>
                        <span className="fs-10">09:00</span>
                        <span className="fs-10">10:00</span>
                        <span className="fs-10">11:00</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceEmployee;
